<script setup lang="ts">
  import type { HeaderSearchStoryblok } from '@/storyblok/component-types-sb'
  import { useMainHeaderStore } from '@/components/main-header/store'

  defineProps<{ item: HeaderSearchStoryblok }>()

  const mainHeaderStore = useMainHeaderStore()
  const { isDesktopSearchOpen } = storeToRefs(mainHeaderStore)
</script>

<template>
  <DialogRoot
    v-model:open="isDesktopSearchOpen"
    modal
  >
    <DialogTrigger as-child>
      <button
        class="flex size-10 items-center justify-center"
        :aria-label="$t('aria.label.search')"
        @click="isDesktopSearchOpen = true"
      >
        <Icon name="common/search" />
      </button>
    </DialogTrigger>

    <DialogPortal>
      <DialogOverlay
        class="fixed inset-0 z-40 bg-black/40 data-[state=closed]:animate-menu-overlay-out data-[state=open]:animate-menu-overlay-in"
        @click="isDesktopSearchOpen = false"
      >
      </DialogOverlay>

      <DialogContent
        class="shadow-xl fixed inset-x-10 top-0 z-50 rounded-lg bg-white pb-6 pt-5 focus:outline-none data-[state=closed]:animate-menu-drop-out data-[state=open]:animate-menu-drop-in"
      >
        <DialogClose as-child>
          <button
            class="absolute right-6 top-6 flex size-10 items-center justify-center p-1"
            :aria-label="$t('aria.label.close')"
          >
            <Icon name="common/close" />
          </button>
        </DialogClose>

        <div class="mx-auto w-1/2">
          <MainHeaderSearchContainer :item="item" />
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
